import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl, intlShape  } from "react-intl";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";

import { getUnit } from "../einheiten/Units";

const StringControlWithUnit = props => (
	<FormGroup validationState={props.validate(
		props.local, props.prop, props.is_required)}>
		<ControlLabel>
			<FormattedMessage id={props.i18n_key} />
		</ControlLabel>
		<FormControl type="text" name={props.prop}
			value={props.local[props.prop].value || ""}
			onChange={props.handleChange} />
		{ props.unit_key !== undefined ?
			<ControlLabel className="control-label-slim">
				{getUnit(props.units[props.unit_key] !== undefined ? props.units[props.unit_key] : props.unit_key).genUnitText(props.intl)}
			</ControlLabel>
			: <React.Fragment />
		}
	</FormGroup>
);

StringControlWithUnit.propTypes = {
	i18n_key: PropTypes.string.isRequired,
	unit_key: PropTypes.string,
	prop: PropTypes.string.isRequired,
	validate: PropTypes.func.isRequired,
	is_required: PropTypes.bool,
	local: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired,
	intl: intlShape.isRequired,
	units: PropTypes.object.isRequired
};

export default injectIntl(StringControlWithUnit);
